/*
  ============================================================================
  bb-hero-slides.js — la sequenza della hero

  REGOLE
  - si ferma quando il mouse ci sta sopra, quando qualcosa dentro ha il fuoco,
    e quando la scheda del browser non e' in primo piano
  - si ferma del tutto se il sistema chiede meno animazioni
  - frecce della tastiera, e scorrimento col dito
  - le slide nascoste non sono raggiungibili con il tab

  NELL'EDITOR DI SHOPIFY
  Quando si seleziona un blocco nella colonna di sinistra, il tema riceve
  shopify:block:select e qui si va su quella slide, altrimenti si modificherebbe
  una slide senza vederla. E lo scorrimento automatico resta fermo mentre il
  blocco e' selezionato, se no scappa via mentre si lavora.
  ============================================================================
*/
(function () {
  'use strict';

  var MENO_MOTO = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function avvia(root) {
    if (!root || root.__bbHs) return;
    root.__bbHs = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bb-hs-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bb-hs-dot]'));
    var prev = root.querySelector('[data-bb-hs-prev]');
    var next = root.querySelector('[data-bb-hs-next]');
    var intervallo = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var autoOn = root.getAttribute('data-autoplay') === 'true' && !MENO_MOTO.matches;

    var i = 0;
    var timer = null;
    var bloccato = false; // editor: blocco selezionato
    // 1 ott 2026: prima la pausa per mouse e fuoco non teneva memoria, e ogni
    // click su freccia o pallino (vai -> riparti) rimetteva in moto la hero
    // col mouse ancora sopra. Ora riparti() guarda questi due stati.
    var sopra = false;  // mouse (o penna) sopra la hero
    var dentro = false; // fuoco da tastiera dentro la hero

    function mostra(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var attivo = k === i;
        s.classList.toggle('is-current', attivo);
        if (attivo) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
        // niente tab sulle slide nascoste
        var a = s.querySelector('a');
        if (a) {
          if (attivo) a.removeAttribute('tabindex');
          else a.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-current', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }

    function riparti() {
      ferma();
      if (!autoOn || bloccato || sopra || dentro || document.hidden) return;
      timer = window.setInterval(function () { mostra(i + 1); }, intervallo);
    }

    function ferma() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    function vai(n) { mostra(n); riparti(); }

    if (prev) prev.addEventListener('click', function () { vai(i - 1); });
    if (next) next.addEventListener('click', function () { vai(i + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { vai(parseInt(d.getAttribute('data-bb-hs-dot'), 10)); });
    });

    // pointer e non mouse: il tocco del dito genera un mouseenter finto che
    // resterebbe acceso fino al tocco successivo fuori, e su telefono la hero
    // smetterebbe di girare dopo un tap su un pallino. Il dito ha gia' i suoi
    // touchstart/touchend qui sotto.
    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      sopra = true; ferma();
    });
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      sopra = false; riparti();
    });
    // conta solo il fuoco da tastiera: il click del mouse su una freccia la
    // mette a fuoco anche lui, e la hero resterebbe ferma dopo che il mouse
    // e' uscito, fino al primo click altrove.
    root.addEventListener('focusin', function (e) {
      var tastiera = true;
      try { tastiera = e.target.matches(':focus-visible'); } catch (err) {}
      dentro = tastiera;
      ferma();
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { dentro = false; riparti(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) ferma(); else riparti();
    });

    root.addEventListener('keydown', function (e) {
      // chi usa le frecce della tastiera sta usando la tastiera: si resta fermi
      // anche se il fuoco era arrivato da un click (1 ott 2026)
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') dentro = true;
      if (e.key === 'ArrowLeft') { e.preventDefault(); vai(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); vai(i + 1); }
    });

    // dito: si conta come scorrimento solo se e' piu' orizzontale che verticale,
    // altrimenti si ruberebbe lo scroll della pagina
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY;
      ferma();
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) vai(dx < 0 ? i + 1 : i - 1);
      else riparti();
      x0 = y0 = null;
    }, { passive: true });

    if (MENO_MOTO.addEventListener) {
      MENO_MOTO.addEventListener('change', function () {
        autoOn = root.getAttribute('data-autoplay') === 'true' && !MENO_MOTO.matches;
        riparti();
      });
    }

    // editor di Shopify
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var k = slides.indexOf(e.target);
      if (k > -1) { bloccato = true; mostra(k); ferma(); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      bloccato = false;
      riparti();
    });

    mostra(0);
    riparti();
  }

  function tutte() {
    document.querySelectorAll('[data-bb-hero-slides]').forEach(avvia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tutte, { once: true });
  } else {
    tutte();
  }

  // la sezione ricaricata dall'editor deve ripartire
  document.addEventListener('shopify:section:load', tutte);
})();
